import request from '@/utils/request'

let AppversionApi = {

  /*app版本记录列表*/
  list(data) {
    return request._post('/shop/plus.appversion.Index/index', data);
},
/*添加app版本记录*/
add(data) {
    return request._post('/shop/plus.appversion.Index/add', data);
},
/*修改app版本记录*/
edit(data) {
    return request._post('/shop/plus.appversion.Index/edit', data);
},
/*删除app版本记录*/
del(data) {
    return request._post('/shop/plus.appversion.Index/del', data);
},
/*app版本记录详情*/
detail(data) {
  return request._post('/shop/plus.appversion.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.appversion.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.appversion.Setting/getSetting', data, errorback);
    },
}
export default AppversionApi;



// WEBPACK FOOTER //
// ./src/api/appversion.js